<template>
  <div class="list-item-container">
    <div class="list-icon-container">
      <template v-if="textIcon === 'check-square-o'">
        <AppIcon class="icon-published table-status-icon" name="check-square-o"></AppIcon>
      </template>
      <template v-else-if="textIcon === 'file-o'">
        <AppIcon class="icon-draft table-status-icon" name="file-o"></AppIcon>
      </template>
      <template v-else-if="textIcon === 'clock-o'">
        <AppIcon class="icon-pending table-status-icon" name="clock-o"></AppIcon>
      </template>
    </div>
    <div class="list-copy">
      <div class="text-heading">
        <slot name="heading">{{ textHeading }}</slot>
      </div>
      <div v-if="textSubHeading.length > 0" class="sub-text-heading" v-html="textSubHeading"></div>
    </div>
  </div>
</template>

<script>
  import AppIcon from '@/components/AppIcon.vue';
  export default {
    props: {
      textIcon: {
        type: String,
        default: false
      },
      textHeading: {
        type: String,
        default: ''
      },
      textSubHeading: {
        type: String,
        default: ''
      }
    },
    components: {
      AppIcon
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $color-published: #00C450;
  $color-draft: #1674CD;
  $color-pending: #1674CD;

  .icon-published {
    color: $color-published;
  }

  .icon-draft {
    color: $color-draft;
  }

  .icon-pending {
    color: $color-pending;
  }

  .list-item-container {
    display: flex;
    align-items: center;

    .text-heading {
      font-size: 13px;
    }

    .sub-text-heading {
      font-size: 10px;
      padding-top: 10px;
    }
  }

  .list-copy {
    display: flex;
    flex-direction: column;
  }

  .list-icon-container {
    padding-right: 15px;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
  }

  .table-status-icon {
    font-size: 1.15rem;
  }
</style>
